
function createDropdownItem(country) {
    var li = document.createElement("li");
    var item = document.createElement("a");
    var item = document.createElement("a");
    var img = document.createElement("img");
    img.src = country.flagUrl; 
    img.alt = "";
    img.classList.add("d-inline-block", "align-top");
    img.width = "16";
    img.height = "16";
    item.appendChild(img);
    var textNode = document.createTextNode(" " + country.name);
    item.appendChild(textNode);
    item.href = country.link || "#";
    item.className = "dropdown-item";
    li.appendChild(item);
    return li;
}

function createHeaderTopBar(currentCountry, countries, topBarLinks) {
    var header = document.createElement("section");
    header.id = "header-top-bar";
    header.className = "flex-container d-none d-md-block";

    var countryDropdown = document.createElement("div");
    countryDropdown.id = "country-dropdown-wrapper";
    var countryButton = document.createElement("button");
    countryButton.id = "dropdown-country";
    countryButton.className = "dropdown-toggle btn btn-link";
    countryButton.type = "button";
    countryButton.setAttribute('aria-controls', 'dropdown-menu');
    countryButton.setAttribute('aria-expanded', 'false');
    var img = document.createElement("img"); // Create an image element
    img.src = currentCountry.flagUrl;
    img.alt = "";
    img.srcset = currentCountry.flagUrl;
    img.sizes = "(max-width: 767px) 16px, 16px";
    img.decoding = "async";
    img.width = "16";
    img.height = "16";
    img.classList.add("d-inline-block", "align-top");

    countryButton.appendChild(img); // Append the image to the button
    countryButton.appendChild(document.createTextNode(" " + currentCountry.name));
    var dropdownArrow = document.createElement("span");
    dropdownArrow.className = "dropdown-arrow";
    dropdownArrow.textContent = " ⏷";
    countryButton.appendChild(dropdownArrow);

    countryButton.onclick = function () {
        var menu = document.querySelector(
            "#country-dropdown-wrapper .dropdown-menu"
        );
        menu.style.display = menu.style.display === "block" ? "none" : "block";
        if (menu.style.display === 'block'){
            countryButton.setAttribute('aria-expanded', 'true');
        }else{
            countryButton.setAttribute('aria-expanded', 'false');
        }
    };
    countryDropdown.appendChild(countryButton);

    var countryMenu = document.createElement("ul");
    countryMenu.className = "dropdown-menu";
    countryMenu.setAttribute('role', 'list');
    countryMenu.id = "dropdown-menu"
    countryMenu.style.display = "none"; // Hide menu by default
    countries.forEach(function (country) {
        if (country.name !== currentCountry.name) {
            countryMenu.appendChild(createDropdownItem(country));
        }
    });
    countryDropdown.appendChild(countryMenu);
    header.appendChild(countryDropdown);

    var getOffer = document.createElement("div");
    getOffer.className = "zin-get-offer";

    var getOfferText = document.createElement("p");
    getOfferText.className = "zin-get-offer-text";
    getOfferText.innerHTML = "IN STOCK - Ships in 1 Business Day";
    getOffer.appendChild(getOfferText);
  
    var getOfferForm = document.createElement("form");
    getOfferForm.className = "zin-get-offer-form";

    var getOfferInput = document.createElement("input");
    getOfferInput.type = "hidden";
    getOfferInput.name = "listId";
    getOfferInput.value = "X8Ui9V";
    getOfferForm.appendChild(getOfferInput);

    var getOfferInput = document.createElement("input");
    getOfferInput.type = "hidden";
    getOfferInput.name = "source";
    getOfferInput.value = "Zinus Website";
    getOfferForm.appendChild(getOfferInput);

    var getOfferInput = document.createElement("input");
    getOfferInput.type = "hidden";
    getOfferInput.name = "consent";
    getOfferInput.value = "email";
    getOfferForm.appendChild(getOfferInput);

    var getOfferLabel = document.createElement("label");
    getOfferLabel.setAttribute("for", "user-email");
    getOfferLabel.className = 'discount-message';
    getOfferLabel.textContent = 'Email';
    getOfferForm.appendChild(getOfferLabel);

    var getOfferInput = document.createElement("input");
    getOfferInput.type = "email";
    getOfferInput.name = "email";
    getOfferInput.placeholder = "Email Address";
    getOfferInput.className = "zin-get-offer-email-input";
    getOfferInput.setAttribute('aria-label', 'Email Address');
    getOfferInput.setAttribute("id", "user-email");
    getOfferInput.setAttribute("autocomplete", "email");
    getOfferInput.required = true;
    getOfferForm.appendChild(getOfferInput);

    var getOfferButton = document.createElement("button");
    getOfferButton.type = "submit";
    getOfferButton.className = "zin-get-offer-button";
    getOfferButton.id = "get-offer-button";
    getOfferButton.textContent = "Get Offer";
    getOfferForm.appendChild(getOfferButton);

    getOffer.appendChild(getOfferForm);

    header.appendChild(getOffer);

    var linksList = document.createElement("ul");
    linksList.className = "header-top-links";
    topBarLinks.forEach(function (link) {
        var listItem = document.createElement("li");
        var anchor = document.createElement("a");
        anchor.href = link.link;
        anchor.textContent = link.name;
        listItem.appendChild(anchor);
        linksList.appendChild(listItem);
    });
    header.appendChild(linksList);

    return header;
}

document.addEventListener("DOMContentLoaded", function () {
    var USButton = document.getElementById('USButton');
    var dropdownMenu = document.getElementById('dropdownMenu');

    USButton.addEventListener('click', function () {
        var displayStyle = dropdownMenu.style.display;
        dropdownMenu.style.display = displayStyle === 'none' ? 'block' : 'none';
    });
    var currentCountry = {
        name: "United States",
        link: "http://www.zinus.com",
        flagUrl:
            "https://cdn.shopify.com/s/files/1/2097/4191/files/United_States_flag.png?v=1689693535",
    };
    var countries = [
        {
            name: "Australia",
            link: "https://www.zinus.com.au/",
            flagUrl:
                "https://cdn.shopify.com/s/files/1/2097/4191/files/Australia_flag.png?v=1689693535",
        },
        {
            name: "Canada",
            link: "https://www.zinus.ca/",
            flagUrl:
                "https://cdn.shopify.com/s/files/1/2097/4191/files/Canada_flag.png?v=1689693534",
        },
        {
            name: "France",
            link: "https://www.zinus.fr/",
            flagUrl:
                "https://cdn.shopify.com/s/files/1/2097/4191/files/France_flag.png?v=1689693535",
        },
        {
            name: "Germany",
            link: "https://www.zinus.com.de/",
            flagUrl:
                "https://cdn.shopify.com/s/files/1/2097/4191/files/Germany_flag.png?v=1689693535",
        },
        {
            name: "Indonesia",
            link: "https://zinus.co.id/",
            flagUrl:
                "https://cdn.shopify.com/s/files/1/2097/4191/files/Indonesia_flag.png?v=1689693535",
        },
        {
            name: "Mexico",
            link: "https://zinus.mx/",
            flagUrl:
                "https://cdn.shopify.com/s/files/1/0790/2425/9372/files/mexico_180x180_e9f4f888-92d5-417d-90b6-57130328b61f.png?v=1722371959",
        },
        {
            name: "Japan",
            link: "https://zinus.jp/",
            flagUrl:
                "https://cdn.shopify.com/s/files/1/2097/4191/files/Japan_flag.png?v=1689693534",
        },
        {
            name: "United Kingdom",
            link: "https://www.zinus.uk/",
            flagUrl:
                "https://cdn.shopify.com/s/files/1/2097/4191/files/United_Kingdom_flag.png?v=1689693534",
        },
        {
            name: "Italy",
            link: "https://www.zinus.it/",
            flagUrl:
                "https://cdn.shopify.com/s/files/1/2097/4191/files/Italy.png?v=1692389350",
        },
        {
            name: "Spain",
            link: "https://www.zinus.es/",
            flagUrl:
                "https://cdn.shopify.com/s/files/1/2097/4191/files/spain.png?v=1692389388",
        },
        {   
            name: "New Zealand",
            link: "https://www.zinus.co.nz/",
            flagUrl:
                "https://cdn.shopify.com/s/files/1/2097/4191/files/Australia_flag.png?v=1689693535",
        },
    ];
    var topBarLinks = [
        { name: "Blog", link: "/blog" },
        { name: "About", link: "/about" },
        { name: "Support", link: "/support" },
    ];

    var headerTopBar = createHeaderTopBar(currentCountry, countries, topBarLinks);

    var existingHeader = document.getElementById("header-top-bar");
    existingHeader.parentNode.replaceChild(headerTopBar, existingHeader);
});

document.addEventListener("DOMContentLoaded", function () {

    document.querySelector('.zin-get-offer-email-input').addEventListener('keyup', function(){
        const email = this.value;
        let submitButton = document.querySelector('#get-offer-button');

        function isValidEmail(email) {
            const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            return regex.test(email);
        }

        if (isValidEmail(email)) {
            submitButton.disabled = false;
        } else {
            submitButton.disabled = true;
        }
    })

    const getOfferForm = document.querySelector(".zin-get-offer-form");
    let getOffer = document.querySelector('.zin-get-offer');

    function handleForm(e) {
      e.preventDefault();
        
      const options = {
        method: 'POST',
        headers: {
        'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          profiles: [{email: document.querySelector('.zin-get-offer-email-input').value}]
        })
      };

      const klaviyoListId = "X8Ui9V";

      fetch(`https://wapi.zinus.com/api/klaviyo/subscribe?listId=${klaviyoListId}`, options)
        .then(res => res.json())
        .catch(err => console.error("Error subscribing to Klaviyo:", err.message))
    
        var thankYouMessage = document.createElement("div");
        thankYouMessage.className = "zin-thank-you-message";
        thankYouMessage.textContent = "";
        thankYouMessage.setAttribute('role', 'status');

        thankYouMessage.setAttribute("aria-live", "polite");
        thankYouMessage.textContent = `Thanks! You've signed up successfully.`;
        getOfferForm.style.display = "none";
        getOffer.appendChild(thankYouMessage);
        thankYouMessage.setAttribute('tabindex', '-1');
        setTimeout(() => {
            thankYouMessage.focus();
        }, 500);
        
    }   

    getOfferForm.addEventListener('submit', handleForm);
});